import { styled } from 'stitches.config'

export const TrustpilotRoot = styled('div', {
  background: '$tertiary-200',
})

export const TrustpilotContainer = styled('div', {
  position: 'relative',
  paddingTop: '60px',
  paddingBottom: '50px',
  '@bp3': {
    paddingTop: '80px',
    paddingBottom: '60px',
  },
})

export const ReviewsWrapper = styled('div', {
  width: '100%',
  maxWidth: '1200px',
  position: 'relative',
  margin: 'auto',
})

export const TrustpilotContent = styled('div', {
  zIndex: 1,
  position: 'relative',
})
